export const visit = (vm, at) => {
at({ "tr": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} / {{totalBytes}}" }, "fileSizeLimit": "Dosya {{size}} boyutundan b\xFCy\xFCk olamaz", "screenCapture": "Ekran yakalama" } } });
};